<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101307"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.packing.serialNumber')">
            <el-input
              v-model="editDialog.form.serialNumber"
              no="queryInput"
              type="number"
              min="1"
              @blur="serialNumberBlur"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.packing.code')">
            <el-input v-model="editDialog.form.code" no="code" :disabled="tenantId!==PLATFORM_TENANT_ID" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.packing.name')">
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.packing.chineseName')">
            <el-input v-model="editDialog.form.chineseName" no="chineseName" />
          </el-form-item>
          <el-form-item
            :label="$t('baseInfo.basicData.packing.interchangeCode')"
            :disabled="tenantId!==PLATFORM_TENANT_ID"
          >
            <el-input v-model="editDialog.form.interchangeCode" no="interchangeCode" />
          </el-form-item>
          <el-form-item
            :label="$t('baseInfo.basicData.packing.isoCode')"
            :disabled="tenantId!==PLATFORM_TENANT_ID"
          >
            <el-input v-model="editDialog.form.isoCode" no="isoCode" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.packing.position')">
            <el-input
              v-model="editDialog.form.position"
              no="position"
              type="number"
              min="1"
              @blur="positionBlur"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.packing.ediCode')">
            <el-input v-model="editDialog.form.ediCode" no="ediCode" />
          </el-form-item>
          <el-form-item v-show="!!editDialog.form.uuid" :label="$t('baseInfo.basicData.packing.userDefinedField')">
            <el-input v-model="editDialog.form.userDefinedField" no="userDefinedField" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="editSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="editCancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('CargoMsg.Cargo_SelectAddPlatformPackages')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-packing />
      <span slot="footer">
        <el-button no="save" type="primary" @click="addFromPlatform">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import basePacking from './basePacking'
import { getUserInfo } from '@/utils/auth'
import { getPackingList, getPackingsByPlatform, savePacking, addPackingByPlatform, savePackings, delPacking } from '@/api/basicData/packing'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'Packing',
  components: { basePacking },
  data() {
    return {
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('baseInfo.basicData.packing.serialNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.packing.code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.packing.chineseName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.packing.englishName'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.packing.ediCode'),
          field: 'ediCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.packing.interchangeCode'),
          field: 'interchangeCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.packing.isoCode'),
          field: 'isoCode',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.packing.position'),
          field: 'position',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.packing.userDefinedField'),
          field: 'userDefinedField',
          width: 100
        }
      ],
      rowData: null,
      tenantId: '',
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNumber: '',
          code: '',
          name: '',
          chineseName: '',
          interchangeCode: '',
          isoCode: '',
          position: '',
          ediCode: '',
          userDefinedField: ''
        }
      },
      platformDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      let queryFunc = getPackingList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getPackingsByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          serialNumber: '',
          code: '',
          name: '',
          chineseName: '',
          interchangeCode: '',
          isoCode: '',
          position: '',
          ediCode: '',
          userDefinedField: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_Package')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_PackageMaintenance')
      }
      this.editDialog.visible = true
    },
    serialNumberBlur() {
      const form = this.editDialog.form
      const val = Number(form.serialNumber)
      if (isNaN(val)) {
        form.serialNumber = ''
        return
      }
      form.serialNumber = val.toFixed(0)
    },
    positionBlur() {
      const form = this.editDialog.form
      const val = Number(form.position)
      if (isNaN(val)) {
        form.position = ''
        return
      }
      form.position = val.toFixed(0)
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.serialNumber && Number(form.serialNumber) != 0) {
        self.$message.warning(self.$t('baseInfo.basicData.packing.serialNumberCheck'))
        return
      }
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.packing.codeCheck'))
        return
      }
      if (!form.interchangeCode) {
        self.$message.warning(self.$t('baseInfo.basicData.packing.interchangeCodeCheck'))
        return
      }
      if (!form.isoCode) {
        self.$message.warning(self.$t('baseInfo.basicData.packing.isoCodeCheck'))
        return
      }
      if (!form.position && Number(form.position) != 0) {
        self.$message.warning(self.$t('baseInfo.basicData.packing.positionCheck'))
        return
      }
      let saveFunc = savePacking
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addPackingByPlatform
      }
      saveFunc(form, form.uuid).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        delPacking(rows[0].uuid).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    showPlatform() {
      if (document.resetBasePacking) {
        document.resetBasePacking()
      } else {
        setTimeout(() => {
          document.resetBasePacking()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBasePackingRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push({
          serialNumber: item.serialNumber,
          code: item.code,
          name: item.name,
          chineseName: item.chineseName,
          interchangeCode: item.interchangeCode,
          isoCode: item.isoCode,
          position: item.position,
          ediCode: item.ediCode
        })
      }
      savePackings(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.platformDialog.visible = false
      })
    }
  }
}
</script>

<style>
</style>
